// extracted by mini-css-extract-plugin
var _1 = "vL1cq7tYChmaWbHF_Kun";
var _2 = "V4w4isaEMD0ZeWSnuGvE";
var _3 = "aDoMMNHqhCqUXtoj5QZB";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "lINQn76Vj7A4YEzIWYsA";
var _13 = "rQlP5xxUxQmuxoS1JGPQ";
var _14 = "G1HPRWD1f9XHuf_sUKvw";
var _15 = "tbeawa5ClYG7IfAGyaeA";
var _16 = "YEuimFyKAoq7h13lf_49";
var _17 = "G0LvnjUkOJXDFNX4M3W4";
var _18 = "ZIfEMjALL2Pw0EZs7JR8";
var _19 = "FYnvGJxioZx5f9cmSYka";
var _1a = "1200px";
var _1b = "992px";
var _1c = "1366px";
var _1d = "768px";
var _1e = "1475px";
var _1f = "576px";
var _20 = "1600px";
var _21 = "320px";
var _22 = "2500px";
var _23 = "PJVPXd9hswq2i_NjFqJG";
var _24 = "mB77EB4liNkDhIAFs1wI";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "center", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "pageError", _13 as "pageErrorCode", _14 as "pageErrorDescription", _15 as "pageErrorDescriptionHasLinks", _16 as "pageErrorDescriptionLinks", _17 as "pageErrorImage", _18 as "pageErrorWrapper", _19 as "reset-button", _1a as "screenlg", _1b as "screenmd", _1c as "screenml", _1d as "screensm", _1e as "screenxlg", _1f as "screenxs", _20 as "screenxxlg", _21 as "screenxxs", _22 as "screenxxxlg", _23 as "single-page-responsive-font-size", _24 as "withMarginBottom" }
export default { "active-media-preview": _1, "base-link": _2, "center": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "pageError": _12, "pageErrorCode": _13, "pageErrorDescription": _14, "pageErrorDescriptionHasLinks": _15, "pageErrorDescriptionLinks": _16, "pageErrorImage": _17, "pageErrorWrapper": _18, "reset-button": _19, "screenlg": _1a, "screenmd": _1b, "screenml": _1c, "screensm": _1d, "screenxlg": _1e, "screenxs": _1f, "screenxxlg": _20, "screenxxs": _21, "screenxxxlg": _22, "single-page-responsive-font-size": _23, "withMarginBottom": _24 }
